import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import API from 'utils/api'
import { buildUrl, formatDate } from 'utils/helpers'
import config from 'config'

export const downloadReportCitizenRegs = createAsyncThunk(
  'analytics/downloadReportCitizenRegs',
  async (params = {}, { getState, rejectWithValue, dispatch }) => {
    try {
      const payload = await API.request(
        buildUrl('/reports/citizen_registrations', params),
        {
          method: 'POST',
          blob: true,
        },
        `${config.redirectUri}/api/v1`
      )
      const url = window.URL.createObjectURL(new Blob([payload]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute(
        'download',
        `Спутник отчёт ${new Date(
          params.start_date
        ).toLocaleDateString()} - ${new Date(
          params.end_date
        ).toLocaleDateString()}.${params.download_type}`
      ) //or any other extension
      document.body.appendChild(link)
      link.click()
      return payload
    } catch (error) {
      console.log(error.stack)
      return rejectWithValue(error)
    }
  }
)

export const downloadReportPartnerProgram = createAsyncThunk(
  'analytics/downloadReportPartnerProgram',
  async (params = {}, { getState, rejectWithValue, dispatch }) => {
    try {
      const payload = await API.request(
        buildUrl('/analytics/reports/partner_program', params),
        {
          dispatch,
          method: 'POST',
        },
        `${config.redirectUri}/api/v2`,
        true
      )

      const url = window.URL.createObjectURL(new Blob([payload]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute(
        'download',
        `Спутник отчёт ${new Date(
          params.start_date
        ).toLocaleDateString()} - ${new Date(
          params.end_date
        ).toLocaleDateString()}.${params.download_type}`
      ) //or any other extension
      document.body.appendChild(link)
      link.click()
      return payload
    } catch {
      return rejectWithValue()
    }
  }
)

export const analytics = createSlice({
  name: 'analytics',
  initialState: {},
  reducers: {},
  extraReducers: {
    [downloadReportCitizenRegs.pending]: (state) => {
      state.pending = true
    },
    [downloadReportCitizenRegs.fulfilled]: (state) => {
      state.pending = false
    },
    [downloadReportCitizenRegs.rejected]: (state) => {
      state.pending = false
    },
  },
})

export const {} = analytics.actions
export default analytics.reducer
